import React, { useMemo } from 'react';
import { ReservationType } from '../../types/reservationType';
import './CompactReservationTypeSelect.scss';
import { AdaptiveSelect } from '../AdaptiveSelect/AdaptiveSelect';

interface Props {
  value: ReservationType[];
  onChange: (types: ReservationType[]) => void;
  reservationTypes: ReservationType[];
  className?: string;
}

interface TypeOption {
  label: string;
  value: string;
  original: ReservationType;
}

// Reservation type filter of the reservations calendar: several types can be chosen and the trigger shows none of them (the
// filter writes its own label next to it).
export const CompactReservationTypeSelect = ({ value, onChange, reservationTypes, className }: Props) => {
  const typeOptions = useMemo(() => {
    return reservationTypes.map((type) => ({
      label: type.name.charAt(0).toUpperCase() + type.name.slice(1),
      value: type.id,
      original: type,
    }));
  }, [reservationTypes]);

  const itemTemplate = (option: TypeOption) => (
    <div className='compact-type-item'>
      <span className='compact-type-name'>{option.label}</span>
    </div>
  );

  const handleChange = (selectedIds: string[]) => {
    const selectedTypes = selectedIds
      .map((id) => typeOptions.find((option) => option.value === id)?.original)
      .filter((type): type is ReservationType => !!type);
    onChange(selectedTypes);
  };

  const convertedValue = useMemo(() => value.map((type) => type.id), [value]);

  return (
    <AdaptiveSelect
      value={convertedValue}
      onChange={handleChange}
      options={typeOptions}
      className={className}
      itemTemplate={itemTemplate}
      selectedItemTemplate={() => null}
      isMultiple
      emptyFilterMessage='No se encontraron tipos de reserva'
      placeholder='Buscar tipo de reserva...'
      modalTitle='Seleccionar tipo de reserva'
      searchPlaceholder='Buscar tipo de reserva'
      isFilter
    />
  );
};
